import { gql } from '@apollo/client';

export const GET_ALL_ORGANISATION_WORKSPACE_DATASETS = gql`
  query GetAllOrgnisationWorkspaceDatasets($input: AllOrganisationWorkspaceDatasesInput) {
    datasets: getAllOrgnisationWorkspaceDatasets(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          description
        }
      }
    }
  }
`;
